
import Transformer from './../transformer'
import { shortDate } from './../../filters'

class MaterialsTransformer extends Transformer {
  static fetch(material) {
    return {
      id: material.id,
      supply: {
        id: material.article.supply_id,
        name: material.article.supply_name,
        family: material.article.supply_family,
        unit: material.article.supply_unit,
        description: material.article.supply_description,
        unitPrice: material.article.supply_unit_price,
      },
      quantity: material.quantity,
      price: material.price,
      totalPrice: +material.price * +material.quantity,
      requisitionId: material.requisition,
    }
  }
}

export default class RequisitionTransformer extends Transformer {
  static fetch(requisition) {
    const consolidated = (requisition.consolidated || []).map(c => {
      const buyOrder = c.buy_order != "" ? c.buy_order : null
      const buyOrderStatus = c.buy_order_status != "" ? c.buy_order_status : null
      const deliveryDate = c.delivery_date != "" ? c.delivery_date : null
      return { 
        name: c.name,
        buyOrder,
        buyOrderStatus,
        completed: buyOrderStatus == 'Completo',
        deliveryDate
      }
    })
    return {
      id: requisition.id,
      folio: requisition.folio,
      email: requisition.email,
      telephone: requisition.telephone,
      campId: requisition.camp.camp_id,
      date: shortDate(requisition.application_date),
      statusId: requisition.status.status,
      campName: requisition.camp.camp_name,
      status: requisition.status.status_name,
      receptorId: requisition.receive.receive_id,
      receptorName: requisition.receive.receive_name,
      applicant: requisition.applicant.applicant_name,
      folioJB: requisition.authorized_project.folio_jb,
      project: requisition.authorized_project.sinister_number,
      address: {
        id: requisition.address.address_id,
        // noExt: requisition.address.address_no_ext,
        // postalCode: requisition.address.addres_CP,
        // colony: requisition.address.address_colony,
        street: requisition.address.address_street,
        state: requisition.address.address_state,
        municipality: requisition.address.address_municipality,
      },
      materials: requisition.materialssinister.map(MaterialsTransformer.fetch),
      consolidated,
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/purchase/requisition.js